export default {
  alerts: {
    unknown: 'неизвестный кошелёк', basis: 'изменение за 24 ч', check: '~30 с',
    flow: { inflow: 'пополнение биржи', outflow: 'вывод с биржи' },
    err: { maxNets_one: 'Можно выбрать максимум {{count}} сеть.', maxNets_few: 'Можно выбрать максимум {{count}} сети.', maxNets_many: 'Можно выбрать максимум {{count}} сетей.', maxNets_other: 'Можно выбрать максимум {{count}} сети.', enableFirst: 'Сначала включите OrcaWatch.' },
    notice: {
      price: 'Цена {{price}} · вход в уровень {{level}} за 24 ч', test: 'Тест', testBody: 'Так выглядит срочное уведомление Orca',
      n4: { title: 'Wall Street · Pre-Market', body: 'Фьючерсы растут, в фокусе отчёт NVIDIA и протокол FOMC' },
      n5: { title: 'Новости по вашим монетам', body: '11 материалов · BTC, ETH, SOL, TON, LINK' },
      n6: { title: 'Завтра: протокол FOMC', body: 'Высокое влияние на BTC, ETH и индексы' },
      n7: { title: 'X Radar · 3 важных поста', body: 'Vitalik Buterin, Solana, Chainlink — подборка за час' },
    },
  },
};
